import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    totalPages: 0,
    usersList: [],
    pageCount: 0, 
    loaderForButton: false,  
    dataLoader: false, 
    size: 0, 
    total: 0, 
    userBasedTabs: 'user-details',
}

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setusersList(state, action) {
            state.usersList = action.payload.pagination ? [...state.usersList, ...action.payload.usersList] : action.payload?.usersList
            state.pageCount = action.payload.pageCount || 0
            state.loaderForButton = action.payload.loaderForButton || false
            state.totalPages = action.payload?.totalPages || 0
            state.dataLoader = action.payload?.dataLoader||false
            state.size = action.payload?.size
            state.total = action.payload?.total
        },
        setUsersLoaderForButton(state, action) {
            state.loaderForButton = action?.payload
        },
        setUsersLoader(state,action){
            state.dataLoader = action?.payload
        },
        clearUsersList(action, state) {
            return initialState
        },
        defaultState(state, action) {
            return initialState
        },
        setUserStates(state, action) {
            const { payload: { key, value } } = action
            state[key] = value;
            return state
        },
    },
})

export const {setUsersLoader, setUsersLoaderForButton, setusersList, clearUsersList} = userSlice.actions

export const userActions = userSlice.actions;

export default userSlice
